import React, { createContext, useContext, useState, useCallback, useMemo } from 'react';

const ToastContext = createContext(null);
let toastId = 0;

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const addToast = useCallback((message, type = 'info', duration = 4000) => {
    const id = ++toastId;
    setToasts(prev => [...prev, { id, message, type }]);
    if (duration > 0) {
      setTimeout(() => setToasts(prev => prev.filter(t => t.id !== id)), duration);
    }
  }, []);

  const removeToast = useCallback((id) => {
    setToasts(prev => prev.filter(t => t.id !== id));
  }, []);

  const toast = useMemo(() => ({
    success: (msg) => addToast(msg, 'success'),
    error: (msg) => addToast(msg, 'error', 5000),
    info: (msg) => addToast(msg, 'info'),
    warn: (msg) => addToast(msg, 'warn', 5000),
  }), [addToast]);

  return (
    <ToastContext.Provider value={toast}>
      {children}
      <div style={styles.container}>
        {toasts.map(t => (
          <div key={t.id} style={{...styles.toast, ...styles[t.type]}} onClick={() => removeToast(t.id)}>
            <span style={styles.icon}>
              {t.type === 'success' ? '\u2713' : t.type === 'error' ? '\u2717' : t.type === 'warn' ? '\u26a0' : '\u2139'}
            </span>
            <span style={styles.message}>{t.message}</span>
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
}

export const useToast = () => useContext(ToastContext);

const styles = {
  container: {
    position: 'fixed', top: 60, right: 16, zIndex: 9999,
    display: 'flex', flexDirection: 'column', gap: 8,
    maxWidth: 360, width: '100%',
  },
  toast: {
    display: 'flex', alignItems: 'center', gap: 10,
    padding: '12px 16px', borderRadius: 10,
    boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
    cursor: 'pointer', fontSize: 13, fontWeight: 500,
    animation: 'slideIn 0.25s ease-out',
  },
  icon: { fontSize: 16, flexShrink: 0 },
  message: { flex: 1 },
  success: { background: '#f0fdf4', color: '#15803d', border: '1px solid #bbf7d0' },
  error: { background: '#fef2f2', color: '#dc2626', border: '1px solid #fecaca' },
  info: { background: '#eff6ff', color: '#1d4ed8', border: '1px solid #bfdbfe' },
  warn: { background: '#fffbeb', color: '#b45309', border: '1px solid #fde68a' },
};
